import type { ComponentProps } from "react"
import type { VariantProps } from "class-variance-authority"
import cn from "@/v2-ui/utils/utils.cn"
import { Input as InputBase } from "./base/InputBase"
import { inputBaseVariants } from "./base/input.base.constants"

export type InputProps = ComponentProps<typeof InputBase> &
  VariantProps<typeof inputBaseVariants>

function Input(props: InputProps) {
  const { className, size, variant, ...inputBaseProps } = props
  return (
    <InputBase
      className={cn(
        "ui-input",
        inputBaseVariants({ size, variant, className }),
      )}
      {...inputBaseProps}
    />
  )
}

export default Input
